import { render, staticRenderFns } from "./IconEntry.vue?vue&type=template&id=225ec8fa&scoped=true&"
import script from "./IconEntry.vue?vue&type=script&lang=js&"
export * from "./IconEntry.vue?vue&type=script&lang=js&"
import style0 from "./IconEntry.vue?vue&type=style&index=0&id=225ec8fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ec8fa",
  null
  
)

export default component.exports